<template>
    <div class="floating-production" @click="toggleProductionList">
        <feather-icon icon="ZapIcon" svgClasses="h-5 w-5 cursor-pointer" />
        {{ productions.length }}

        <transition name="fadeInUp">
            <div v-if="isOpen" class="production-dropdown" @click.stop>
                <div v-for="(prod, index) in productions" :key="index" class="production-item">
                    <span>
                        <span style="font-size:24px">+{{ Number(prod.qty).toFixed(2) }} {{ prod.uom }} <small>({{ Number(prod.m3).toFixed(2) }} m3)</small></span><br />
                        Quotation #{{ prod.quotationref }} → {{ prod.category }} {{ prod.product }}
                    </span>
                    <feather-icon icon="XCircleIcon" svgClasses="h-12 w-12 cursor-pointer"
                        @click.stop="removeProduction(index)" />
                </div>

                <!-- Bouton : utilisation de :disabled et d'un indicateur 'isLoading' -->
                <vs-button color="green" class="start-production-btn" @click="!isLoading && addToWeeklyProduction()"
                    :disabled="isLoading">
                    <!-- Quand isLoading est true, on peut afficher un petit texte ou icône de chargement -->
                    <span v-if="isLoading">Loading...</span>
                    <span v-else>ADD TO WEEKLY PRODUCTION (WEEK {{ getCurrentWeek() }}, {{ getCurrentYear() }})</span>
                </vs-button>
            </div>
        </transition>
    </div>
</template>

<script>
import moment from "moment"
import axios from "@/axios.js"

export default {
    props: {
        productions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isOpen: false,
            isLoading: false // <=== nouvel état
        }
    },
    methods: {
        getCurrentWeek() {
            return moment().week()
        },
        getCurrentYear() {
            return moment().year()
        },
        toggleProductionList() {
            this.isOpen = !this.isOpen
        },
        removeProduction(index) {
            this.$emit("update-productions", index)
        },
        addToWeeklyProduction() {
            this.isLoading = true
            // Ta requête ou autre logique
            axios.post("/operation/createproductionfromdashboard", {
                products: this.productions,
                week: this.getCurrentWeek(),
                year: this.getCurrentYear()
            })
                .then(() => {
                    this.$emit("production-done", this.productions)
                    // Au lieu de réactiver direct, on attend 5s
                    setTimeout(() => {
                        this.isLoading = false
                    }, 8000)
                })
                .catch(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>
<style scoped>
.floating-production {
    z-index: 100000;
    position: fixed;
    bottom: 40px;
    right: 20px;
    background: #007bff;
    color: white;
    padding: 12px 16px;
    border-radius: 50px;
    cursor: pointer;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Transition classes */
.fadeInUp-enter-active,
.fadeInUp-leave-active {
    transition: all 0.2s ease;
}

.fadeInUp-enter {
    opacity: 0;
    transform: translateY(10px);
}

.fadeInUp-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.production-dropdown {
    position: absolute;
    bottom: 50px;
    right: 0;
    width: 800px;
    background: white;
    color: black;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.production-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
}

.start-production-btn {
    display: inline-block;
    text-align: center;
    width: 100%;
    padding: 8px;
    background: #28a745;
    font-size: 12px;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin-top: 10px;
}
</style>